import { type NonProfitData, type NonProfitHandlers } from '@ctct/application-layer';
import { NonProfitToggle } from '@ctct/payflow-ui';
import type { NonProfitHooks } from '@ctct/state-client-layer';

interface Props {
  data: NonProfitData;
  handlers: NonProfitHandlers;
  hooks: NonProfitHooks;
  isSingleBillChildAccount?: boolean;
}

export const NonProfitWidgetContent = ({ data, handlers, hooks, isSingleBillChildAccount }: Props) => {
  const isNonProfit = data.getIsNonProfit();
  const { nonprofitLabel } = data.getLabels();

  const disabled = Boolean(hooks.useDisabled() || isSingleBillChildAccount);

  return (
    <NonProfitToggle
      value={isNonProfit}
      onChange={handlers.onNonprofitChange}
      label={nonprofitLabel}
      disabled={disabled}
    />
  );
};
